var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCup = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 10,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.075 4.494V1.387h8.234v3.107a4.117 4.117 0 1 1-8.234 0ZM.875.376c0-.105.085-.189.189-.189h10.514a2.048 2.048 0 0 1 1.396 3.545L11.54 5.068l-.07.066a5.318 5.318 0 0 1-10.596-.64V.376Zm11.28 2.479-.614.572v-2.04h.037a.848.848 0 0 1 .578 1.468Z",
  fill: "#00546F"
})));
export default SvgCup;